import { Location, matchPath } from "react-router-dom";

const isSelected = (location: Location, pattern: string) => {
  return matchPath(pattern, location.pathname) !== null;
};

export default isSelected;
